import sanitizeHtml from 'sanitize-html';

const options = {
    allowedAttributes: {
        '*': ['style'],
        'a': ['href', 'target'],
    },
    parser: {
        decodeEntities: false,
    },
};

export const sanitizeComment = (comment: string): string =>
    sanitizeHtml(comment, options).trim();
